<script>
export default {
  data: () => ({
    name: 'mouseDistance',
    moveTimeout: null,
    moveStartEvent: null,
    movePrevEvent: null,

    value: 0,
    eventStart: null,
    eventEnd: null,
  }),
  computed: {
    behaviour() {
      const { value, eventStart, eventEnd } = this;
      return { value, eventStart, eventEnd };
    },
  },
  mounted() {
    this.bindEvents();
  },
  beforeDestroy() {
    this.unbindEvents();
  },
  methods: {
    bindEvents() {
      window.addEventListener('mousemove', this.trackDistance);
    },
    unbindEvents() {
      window.removeEventListener('mousemove', this.trackDistance);
    },
    trackDistance(event) {
      if (!this.eventStart) this.eventStart = Date.now();
      clearTimeout(this.moveTimeout);
      if (!this.moveStartEvent) this.moveStartEvent = event;

      this.moveTimeout = setTimeout(() => {
        this.moveStartEvent = null;
      }, 100);

      if (this.movePrevEvent) {
        const travelledX = Math.abs(this.moveStartEvent.pageX - event.pageX);
        const travelledY = Math.abs(this.moveStartEvent.pageY - event.pageY);
        this.value += parseInt(travelledX + travelledY, 10);
        this.eventEnd = Date.now();
      }

      this.movePrevEvent = event;
    },
  },
  render: () => '',
};
</script>
